import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchStaffList(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/auth/staffs', {
            params: queryParams,
          })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchStaffProfile(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/auth/staffs/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchProgramList(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/auth/programs', {
            params: queryParams,
          })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchProgramApplicationsList(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/auth/programs/application/${queryParams.userId}`, {
            params: queryParams,
          })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchTaskList(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/auth/application-tasks', {
            params: queryParams,
          })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
